import { AuthLayout, AuthTitle } from './AuthLayout';
import { useHistory } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { IOrganisation, useStores } from '../../stores';
import { Button, Card, Icon, majorScale, Spinner } from '../../npaper';
import Box from 'ui-box';
import { OrganisationIcon } from '../settings/OrganisationIcon';

export const AuthChooseOrganisation = () => {
  const { authStore } = useStores();
  const history = useHistory();

  const [orgs, setOrgs] = useState<IOrganisation[]>();

  useEffect(() => {
    if (!authStore.isSignedIn) {
      history.push('/auth');
      return;
    }
    let isSub = true;
    authStore
      .setup()
      .then(([me, orgs]) => {
        if (isSub) {
          setOrgs(orgs);
        }
      })
      .catch((err) => {
        console.error(err);
        history.push('/auth');
      });
    return () => {
      isSub = false;
    };
  }, [authStore, history]);

  const chooseOrganisation = (organisation: IOrganisation) => {
    authStore.setCurrentOrganisation(organisation);
    history.push('/');
  };

  return (
    <AuthLayout>
      <AuthTitle
        title="Vælg en konto"
        sub={`Hej ${authStore.me ? authStore.me.name : ''}`}
      />
      {orgs ? (
        orgs.map((organisation) => (
          <Card
            interactive
            key={organisation.id}
            display="grid"
            padding={majorScale(1)}
            gridTemplateColumns="50px 1fr auto"
            columnGap={majorScale(1)}
            alignItems="center"
            width="100%"
            onClick={() => chooseOrganisation(organisation)}
            marginBottom={majorScale(1)}
          >
            <OrganisationIcon organisation={organisation} />
            <p>{organisation.name}</p>
            <Box>
              <Icon icon="chevron-right" />
            </Box>
          </Card>
        ))
      ) : (
        <Spinner size={16} />
      )}

      <Button
        iconLeft="add"
        minimal={!orgs || orgs.length > 0}
        onClick={() => history.push('/auth/sign-up')}
      >
        Opret ny konto
      </Button>
    </AuthLayout>
  );
};
